module.exports = __webpack_public_path__ + "static/media/line-smooth-icon.1f388abd.svg";